import {
  Box,
  Button,
  Center,
  CircularProgress,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { column } from "./../helpers/index";
import {
  useVehicleMarkDelete,
  useVehicleMarkList,
  useVehicleMarkSet,
} from "../hooks";
import { FuncButton } from "../../customComponents/components/FuncButton";

export const PromoStatusListScreen = () => {
  const [activeMarkId, setActiveMarkId] = useState(null);
  const toast = useToast();
  const titleRef = useRef<HTMLInputElement>();
  const bonusCostRef = useRef<HTMLInputElement>();
  const descriptionRef = useRef<HTMLInputElement>();
  const iconRef = useRef<HTMLInputElement>();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { vehicleMarkListLoading, vehicleMarkList, getVehicleMarkList } =
    useVehicleMarkList();
  const { vehicleMarkSetLoading, getVehicleMarkSet } = useVehicleMarkSet();
  const { vehicleMarkDeleteReq, vehicleMarkDeleteLoading } =
    useVehicleMarkDelete();

  useEffect(() => {
    getVehicleMarkList();
  }, []);

  const loading =
    vehicleMarkListLoading || vehicleMarkSetLoading || vehicleMarkDeleteLoading;

  const onClose = () => setModalIsOpen(false);

  const onSubmit = async () => {
    const title = titleRef?.current?.value;
    const bonus_cost = bonusCostRef?.current?.value;
    const description = descriptionRef?.current?.value;
    const image = iconRef?.current?.files[0];
    if (title) {
      const reqObj = { title, bonus_cost, description, image };
      if (activeMarkId) {
        //@ts-ignore
        reqObj.id = activeMarkId;
      }
      //@ts-ignore
      const res = await getVehicleMarkSet(reqObj);
      if (res.data.success) {
        toast({
          title: "Статус создан ",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      }
      getVehicleMarkList();
      setModalIsOpen(false);
    }
  };

  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Статусы системы лояльности</Heading>}
        onClick={() => {
          setActiveMarkId(null);
          setModalIsOpen(true);
        }}
        linkLabel="Добавить статус"
      >
        {loading ? (
          <Container height="calc(100vh - 240px)">
            <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
          </Container>
        ) : (
          <TableHead column={column}>
            {vehicleMarkList.map(
              ({ id, title, bonus_cost, description, image }) => (
                <Tr key={id}>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {id}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {title}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {bonus_cost}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {description}
                    </Text>
                  </Td>
                  <Td>
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${image}`}
                    />
                  </Td>
                  <Td isNumeric>
                    <FuncButton
                      onClick={() => {
                        setActiveMarkId(id);
                        setModalIsOpen(true);
                        setTimeout(() => {
                          titleRef.current.value = title;
                          bonusCostRef.current.value = bonus_cost;
                          descriptionRef.current.value = description;
                        }, 500);
                      }}
                    >
                      РЕДАКТИРОВАТЬ
                    </FuncButton>
                  </Td>
                  <Td isNumeric>
                    <Button
                      marginLeft={"20px"}
                      colorScheme="red"
                      onClick={() => {
                        if (
                          window.confirm("Пожалуйста, подтвердите удаление")
                        ) {
                          vehicleMarkDeleteReq({ id }).then(() => {
                            getVehicleMarkList();
                          });
                        }
                      }}
                    >
                      Удалить
                    </Button>
                  </Td>
                </Tr>
              )
            )}
          </TableHead>
        )}
      </PageHead>
      <Modal isOpen={modalIsOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Добавить статус</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : (
              <>
                <FormControl>
                  <FormLabel>Наименование</FormLabel>
                  <Input ref={titleRef} placeholder="Наименование" />
                </FormControl>
                <FormControl marginTop="20px">
                  <FormLabel>Количество баллов до достижения (число)</FormLabel>
                  <Input
                    ref={bonusCostRef}
                    placeholder="Количество баллов до достижения (число)"
                  />
                </FormControl>
                <FormControl marginTop="20px">
                  <FormLabel>Описание (что получит пользователь)</FormLabel>
                  <Input
                    ref={descriptionRef}
                    placeholder="Описание (что получит пользователь)"
                  />
                </FormControl>
                <FormControl marginTop="20px">
                  <FormLabel>Иконка</FormLabel>
                  <Input type="file" ref={iconRef} placeholder="Иконка" />
                </FormControl>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Отменить
            </Button>
            <Button
              disabled={loading}
              colorScheme="blue"
              mr={3}
              onClick={onSubmit}
              marginLeft="20px"
            >
              {activeMarkId ? "Редактировать" : "Создать"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
